import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useScrollToHash } from "../hooks/useScrollToHash";
import Popup from './Popup';

const hoursByDay = {
    0: ['Open Mon', '9AM'], // Sunday
    1: ['Available until', '5PM'], // Monday
    2: ['Available until', '5PM'], // Tuesday
    3: ['Available until', '5PM'], // Wednesday
    4: ['Available until', '5PM'], // Thursday
    5: ['Available until', '5PM'], // Friday
    6: ['Open Mon', '9AM'], // Saturday
};

function Header() {
    useScrollToHash();

    const [showPopup, setShowPopup] = useState(false);
    const [todayHours, setTodayHours] = useState({ label: '', time: '' });
    useEffect(() => {
        const today = new Date().getDay();
        const dayHours = hoursByDay[today as keyof typeof hoursByDay];
        setTodayHours({ label: dayHours[0], time: dayHours[1] });
    }, []);

    return (
        <>
            <header>
                <div className="container">
                    <Link className="logo" to="/" rel="nofollow">
                        <div className="group flex">
                            <span className="logo logo-text main">CompareYachtCharters</span>
                        </div>
                    </Link>
                    <nav className="desktop-nav">
                        <Link to="/#discover" rel="nofollow">Discover</Link>
                        <Link to="/#yachtCollections" rel="nofollow">Yacht Collections</Link>
                        <Link to="/#offers" rel="nofollow">Picks</Link>
                    </nav>
                    {/* <div className="contact"> */}
                    {/* <div className="phone">
                            <div className="opening-hours">
                                <span className="top-line">
                                    {todayHours.label} <strong className="bold">{todayHours.time}</strong>
                                </span>
                            </div>
                            <span className="bottom-line bold">0207 881 1234</span>
                        </div> */}
                    {/* <!-- <button className="cta">Get expert help</button> --> */}
                    {/* </div> */}
                    <div className="flex-group">
                        <div className="phone-mobile">
                            <a href="tel:+4402078811234">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                >
                                    <path
                                        d="M15.873 15.1673C16.0055 15.0751 16.1579 15.0189 16.3164 15.004C16.4748 14.9889 16.6344 15.0153 16.7806 15.081L22.4194 17.7223C22.6094 17.8072 22.768 17.9543 22.8715 18.1413C22.9749 18.3283 23.0178 18.5454 22.9933 18.7599C22.8076 20.2112 22.124 21.5426 21.0696 22.5066C20.0152 23.4704 18.6619 24.0011 17.2612 24C12.9485 24 8.81238 22.2089 5.76282 19.0206C2.71323 15.8326 1 11.5084 1 6.99962C0.998932 5.53534 1.50659 4.1205 2.42855 3.01819C3.35053 1.9159 4.62405 1.20119 6.0123 1.00699C6.21751 0.981495 6.4251 1.02618 6.60401 1.13433C6.78291 1.2425 6.92349 1.40832 7.0047 1.607L9.53118 7.50713C9.59325 7.65867 9.61854 7.8239 9.60477 7.98812C9.59099 8.15234 9.53861 8.31046 9.45226 8.4484L6.89709 11.6247C6.80647 11.7677 6.75286 11.9328 6.74155 12.104C6.73023 12.2751 6.76157 12.4463 6.83253 12.601C7.82136 14.7173 9.91379 16.8786 11.9441 17.9024C12.0928 17.9762 12.2574 18.0082 12.4215 17.9953C12.5857 17.9823 12.7438 17.925 12.8803 17.8287L15.873 15.1673Z"
                                        stroke="black"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        fill="none"
                                    ></path>
                                </svg>
                            </a>
                        </div>
                        <button className="burger" onClick={() => setShowPopup(true)} type='button'>
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <line
                                    x1="3"
                                    y1="7.5"
                                    x2="29"
                                    y2="7.5"
                                    stroke="rgb(0, 0, 0)"
                                ></line>
                                <line
                                    x1="3"
                                    y1="15.5"
                                    x2="29"
                                    y2="15.5"
                                    stroke="rgb(0, 0, 0)"
                                ></line>
                                <line
                                    x1="3"
                                    y1="23.5"
                                    x2="29"
                                    y2="23.5"
                                    stroke="rgb(0, 0, 0)"
                                ></line>
                            </svg>
                        </button>
                    </div>
                </div>
            </header>

            <nav className="nav-menu">
                <button className="close" onClick={() => setShowPopup(false)} type='button'>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                    >
                        <path d="M19 1L10 10M1 19L10 10M10 10L19 19L1 1" stroke="black" />
                    </svg>
                </button>
                <Link to="/#discover" rel="nofollow">Discover</Link>
                <Link to="/#yachtCollections" rel="nofollow">Yacht Collections</Link>
                <Link to="/#offers" rel="nofollow">Picks</Link>
                {/* <!-- <a href="#">Contact Us</a> --> */}

                {/* <div className="contact mobile">
                    <div className="phone">
                        <span className="opening-hours"></span>
                        <span className="bottom-line bold">0207 881 1234</span>
                    </div>
                    <button className="cta">Get expert help</button>
                </div> */}
            </nav>

            <div className="overlay" onClick={() => setShowPopup(false)}></div>

            {showPopup && <Popup onClose={() => setShowPopup(false)} />}
        </>
    );
}

export default Header;